import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="bg-[#F9F9F8] min-h-screen">
      <article className="max-w-3xl mx-auto px-6 py-16">
        <div className="eyebrow text-red-600 mb-3">Acuerdo de servicio</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">
          Términos y Condiciones
        </h1>
        <p className="mt-3 text-sm font-mono text-gray-500">Vigencia: 22 de febrero de 2026</p>

        <S title="1. Objeto">
          <p>borra-me.com SpA (en adelante, “borra-me”) ofrece un servicio de gestión automatizada de solicitudes ARCOP (Acceso, Rectificación, Cancelación, Oposición y Portabilidad) ante brokers de datos personales en Chile, conforme a la Ley 21.719.</p>
        </S>

        <S title="2. Servicio">
          <p>El plan único cuesta <b>$39.990 CLP como pago único</b> (Webpay Transbank), sin permanencia ni renovaciones automáticas, e incluye:</p>
          <ul className="list-disc pl-6">
            <li>Escaneo periódico de los principales brokers y rutificadores chilenos.</li>
            <li>Envío de solicitudes ARCOP a Empresas (bancos, telcos, retail) declaradas por el titular, para detener spam y suprimir datos no obligatorios.</li>
            <li>Generación y envío automático de solicitudes ARCOP firmadas con tus datos.</li>
            <li>Seguimiento del cumplimiento del plazo legal (30 días corridos — art. 15 Ley 21.719).</li>
            <li>Generación automática del PDF de denuncia ante la APDP cuando el responsable no responde en plazo.</li>
            <li>Re-escaneo cada 45 días y dashboard de estado en tiempo real.</li>
          </ul>
        </S>

        <S title="3. Rol de borra-me">
          <p>borra-me actúa como <b>apoderado técnico</b> del titular para gestionar y enviar las solicitudes ARCOP. NO ofrecemos asesoría legal personalizada ni representamos judicialmente al titular. La presentación final de denuncias ante la APDP corresponde al titular o a un abogado habilitado.</p>
        </S>

        <S title="4. Obligaciones del usuario">
          <ul className="list-disc pl-6">
            <li>Proporcionar datos verídicos (nombre, RUT, email, teléfono).</li>
            <li>Ser el titular efectivo de los datos personales que se solicitan eliminar.</li>
            <li>No utilizar el servicio para suplantar la identidad de terceros.</li>
            <li>Mantener su contraseña en confidencialidad.</li>
          </ul>
        </S>

        <S title="5. Pago y cancelación">
          <p>El pago es <b>único</b> y se procesa a través de Webpay Transbank (comercio 597052144643). No hay renovación automática. Política de devolución: si el servicio no funciona dentro de los primeros 7 días desde la fecha de pago, te devolvemos el 100%.</p>
        </S>

        <S title="6. Limitación de responsabilidad">
          <p>borra-me se compromete a enviar las solicitudes y a hacer el seguimiento, pero NO podemos garantizar que cada broker cumpla con la eliminación. Si un broker no responde, generamos automáticamente el PDF de denuncia ante la APDP, pero la sanción al broker depende de la autoridad. La responsabilidad de borra-me se limita al monto del servicio efectivamente pagado en los últimos 12 meses.</p>
        </S>

        <S title="7. Propiedad intelectual">
          <p>Los textos, código, diseño, ilustraciones y marcas de borra-me.com son propiedad de borra-me.com SpA. Queda prohibida su reproducción sin autorización expresa por escrito.</p>
        </S>

        <S title="8. Ley aplicable y jurisdicción">
          <p>Este contrato se rige por las leyes de Chile. Cualquier controversia se someterá a los Tribunales Ordinarios de Justicia de Santiago.</p>
        </S>

        <S title="9. Contacto">
          <p>Email: <a href="mailto:contacto@borra-me.com" className="underline">contacto@borra-me.com</a> · DPO: <a href="mailto:privacidad@borra-me.com" className="underline">privacidad@borra-me.com</a></p>
        </S>

        <div className="mt-12 pt-6 border-t border-gray-200 text-xs font-mono text-gray-500">
          <Link to="/legal/privacidad" className="underline">Política de Privacidad</Link> · <Link to="/legal/cookies" className="underline">Política de Cookies</Link>
        </div>
      </article>
    </div>
  );
}

function S({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-display text-xl font-bold text-gray-900 border-l-2 border-[#E63946] pl-3 mb-3">{title}</h2>
      <div className="text-gray-700 leading-relaxed space-y-3">{children}</div>
    </section>
  );
}
